import { render, staticRenderFns } from "./TheAdminHeaderDropdown.vue?vue&type=template&id=ab86bc0a&scoped=true"
import script from "./TheAdminHeaderDropdown.vue?vue&type=script&lang=js"
export * from "./TheAdminHeaderDropdown.vue?vue&type=script&lang=js"
import style0 from "./TheAdminHeaderDropdown.vue?vue&type=style&index=0&id=ab86bc0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab86bc0a",
  null
  
)

export default component.exports